import { observer } from 'mobx-react-lite';
import {
    Formik,
    Form,
    Field,
    ErrorMessage
} from 'formik';
import { fullTempRegisterUserReferalSchema, tempRegisterUserReferalSchema } from '../../../app/common/formValidations/validationSchemes';
import { useStore } from '../../../app/stores/store';
import { Box, Button, FormControl, Grid, TextField, Typography } from '@mui/material';
import { withNavbar } from '../../../app/layout/HOC';
import { useEffectOnce } from 'usehooks-ts';
import { collectionFormStyles } from '../../basicUser/basicUserForms/collectionFormStyles';
import useQuery from '../../../app/common/util/hooks';
import ValidationErrors from '../../errors/ValidationErrors';
import { ReferalRegisterSignupForm } from '../../../app/models/user';

const RegisterSignup = () => {
    const { commonStore, userStore } = useStore();

    useEffectOnce(() => {
        commonStore.resetAppData();
    })

    const email = useQuery().get('email') as string;
    const token = useQuery().get('token') as string;

    const initialValues: ReferalRegisterSignupForm = {
        email: '', token: '', fullName: '',
        password: '', confirmPassword: '', error: null
    };

    return (
        <Box component="div" sx={{ display: 'flex', justifyContent: 'center', alignContent: 'center', pt: 15 }}>
            <Box component="div" sx={collectionFormStyles.refferalSignUpFormContainer}>
                <Box component="div">
                    <Typography variant="h5" textAlign={'center'} sx={{ p: 2 }}>Register sign up</Typography>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={tempRegisterUserReferalSchema}
                        onSubmit={(values, { setSubmitting, setErrors }) => {
                            values = {
                                ...values,
                                email: email,
                                token: token
                            }
                            fullTempRegisterUserReferalSchema
                                .validate(values)
                                .then(() => {
                                    userStore.addNewRegisterReferal(values)
                                        .catch(error => setErrors({ error }))
                                })
                                .catch(() => {
                                });
                            // resetPassword(token as string, email as string, values.password, values.confirmPassword);
                            setSubmitting(false);
                        }}
                    >
                        {({ values,
                            handleChange,
                            handleBlur,
                            errors,
                            isValid
                        }) => {
                            return (
                                <Form className="w100" autoComplete="off">
                                    <Grid container rowSpacing={1}>
                                        {/* <FormControl fullWidth>
                                            <Typography variant='caption'>User Full Name</Typography>
                                            <Field
                                                type="text"
                                                component={TextField}
                                                id="fullName"
                                                name="fullName"
                                                placeholder="Tier 1 Asset"
                                                fullWidth
                                                margin="normal"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.fullName}
                                                variant="outlined"
                                            />
                                            <ErrorMessage className='errorText' name="fullName" component="div" />
                                        </FormControl> */}
                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <Typography variant='caption'>Password</Typography>
                                                <Field
                                                    type="password"
                                                    component={TextField}
                                                    id="password"
                                                    name="password"
                                                    placeholder="Password"
                                                    fullWidth
                                                    margin="normal"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.password}
                                                    variant="outlined" />
                                                <ErrorMessage className='errorText' name="password" component="div" />
                                            </FormControl>
                                            <FormControl fullWidth>
                                                <Typography variant='caption'>Confirm Password</Typography>
                                                <Field
                                                    type="password"
                                                    component={TextField}
                                                    id="confirmPassword"
                                                    name="confirmPassword"
                                                    placeholder="confirmPassword"
                                                    fullWidth
                                                    margin="normal"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.confirmPassword}
                                                    variant="outlined" />
                                                <ErrorMessage className='errorText' name="confirmPassword" component="div" />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                    <FormControl fullWidth>
                                        <label>
                                            <Field
                                                type="checkbox"
                                                id="isTermAndConditionAccepted"
                                                name="isTermAndConditionAccepted"
                                            />
                                            &nbsp; <a href='/termsandconditions' target='_blank' className='errorTextBlack'>I agreed to the Terms and conditions</a>
                                        </label>
                                        <ErrorMessage className='errorText' name="isTermAndConditionAccepted" component="div" />
                                    </FormControl>
                                    <ErrorMessage
                                        name='error' render={() =>
                                            <ValidationErrors errors={errors.error} />
                                        }
                                    />
                                    <Button sx={{ mt: 2 }} type="submit" fullWidth variant="contained" disabled={!isValid} > Save</Button>
                                </Form>
                            );
                        }}
                    </Formik>
                </Box>

            </Box>
        </Box>

    )
}
const RegisterSignupFormPage = withNavbar(observer(RegisterSignup));
export default RegisterSignupFormPage;